/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import ScrollLock from 'components/ScrollLock';
import styles from './News.scss';
import iconArrow from 'assets/images/icons/arrow-right.svg';
import { monthToString, formatDate } from 'utils';
import { loadNews } from 'actions/building';
import { setPopUp } from 'actions/environment';
import { withTranslation } from 'react-i18next';
import { linkifyText } from '../helper';
import { gaEvent, trackGA } from 'services/ga';

class News extends Component {
  handleShowNewsText = (dateUpdate, name) => {
    const { building, t } = this.props;

    this.handleTrackEvent({ eventName: 'buildingNewsLinksClick' });

    this.props.setPopUp(
      <div className={styles.NewsPopupWrap}>
        <div className={styles.PopupTitle}>
          <span>
            {t('components.building.main.news.titleBig', {
              title: building.data.title,
            })}
          </span>
        </div>
        <ScrollLock>
          <div className={cn(styles.PopupNewsList, 'custom-scrollbar')}>
            <div className={styles.PopupNewsItem} key={dateUpdate}>
              <time className={styles.PopupNewsItemDate}>{formatDate(dateUpdate)}</time>
              <p className={styles.PopupNewsItemText}>{linkifyText(name)}</p>
            </div>
          </div>
        </ScrollLock>
      </div>,
      {
        className: styles.NewsPopup,
        contentClassName: styles.NewsPopupContent,
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
        onClose: () => this.handleTrackEvent({ eventName: 'buildingNewsDialogClose' }),
      }
    );
  };

  handleMoreClick = (e) => {
    e.preventDefault();
    const { building, t } = this.props;
    const { news } = building;

    this.handleTrackEvent({ eventName: 'buildingNewsLinksClick' });

    this.props.setPopUp(
      <div className={styles.NewsPopupWrap}>
        <div className={styles.PopupTitle}>
          <span>
            {t('components.building.main.news.titleBig', {
              title: building.data.title,
            })}
          </span>
        </div>
        <ScrollLock>
          <div className={cn(styles.PopupNewsList, 'custom-scrollbar')}>
            {news.map(({ dateUpdate, name }, i) => {
              const message = linkifyText(name);

              return (
                <div className={styles.PopupNewsItem} key={`${i}-${dateUpdate}-${name}`}>
                  <time className={styles.PopupNewsItemDate}>{formatDate(dateUpdate)}</time>
                  <p className={styles.PopupNewsItemText}>{message}</p>
                </div>
              );
            })}
          </div>
        </ScrollLock>
      </div>,
      {
        className: styles.NewsPopup,
        contentClassName: styles.NewsPopupContent,
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false,
        onClose: () => this.handleTrackEvent({ eventName: 'buildingNewsDialogClose' }),
      }
    );
  };

  UNSAFE_componentWillMount() {
    if (!this.props.isNewsLoading) {
      this.props.loadNews(this.props.params.id);
    }
  }

  handleTrackEvent = ({ eventName }) => {
    const { building, profile, objectType } = this.props;
    const { title, id } = building.data;

    trackGA(
      gaEvent[eventName]({
        productType: objectType,
        productName: title,
        productID: id,
        user_id: profile.id,
      })
    );
  };

  render() {
    const { className, building, client, t } = this.props;
    const { news } = building;

    const sortedNews =
      news &&
      news.sort((a, b) => {
        if (a.dateUpdate > b.dateUpdate) return -1;
        if (a.dateUpdate < b.dateUpdate) return 1;
        return 0;
      });

    return news && news.length ? (
      <div className={cn(styles.News, className)}>
        <h3 className={client ? styles.TitleClient : styles.Title}>
          {t('components.building.main.news.title')}
        </h3>
        <div className={styles.NewsList}>
          {sortedNews.slice(0, 3).map(({ dateUpdate, name }, i) => (
            <div className={styles.NewsItem} key={`${dateUpdate}-${name}-${i}`}>
              <time className={styles.NewsItemDate}>{formatDate(dateUpdate)}</time>
              <p className={styles.NewsItemText}>{linkifyText(name, 100)}</p>
              {name.length > 100 ? (
                <span
                  onClick={() => this.handleShowNewsText(dateUpdate, name)}
                  className={styles.NewsItemLink}
                >
                  {t('components.building.main.news.readMore')}
                </span>
              ) : null}
            </div>
          ))}

          {news.length > 3 ? (
            <span className={styles.AllNews} onClick={this.handleMoreClick}>
              {t('components.building.main.news.seeAll')} ({news.length}){' '}
              <img src={iconArrow} alt="" />
            </span>
          ) : (
            ''
          )}
        </div>
      </div>
    ) : null;
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      isNewsLoading: state.building.isNewsLoading,
    }),
    { loadNews, setPopUp }
  )(News)
);



// WEBPACK FOOTER //
// ./src/components/Building/Main/News/News.js